export default __webpack_public_path__ + "static/media/banner_privacy_policy.db5fae36.jpg";